import React, { useState } from "react";
import COE from "../coe/COE";
import InmateList from "../inmate_list/InmateList";
import Loading from "../Loading";
import DateSelect from "../DateSelect";
import ToggleWithCheck from "../ToggleWithCheck";
import {
  ArrowNarrowRightIcon,
  PlusCircleIcon,
  MinusCircleIcon,
} from "@heroicons/react/solid";
import {
  insert, // insert into inmate list
  reset, // reset inmate list
  showWarning01,
  hideWarning01,
  showError02,
  hideError02,
  showFailed,
  hideFailed,
  showLoading,
  hideLoading,
  showError03,
  hideError03,
} from "../inmate_list/inmatesSlice";
import Dropdown from "../Dropdown";
import { useSelector, useDispatch } from "react-redux";
import { env } from "../../environment";
import SearchErrors from "../SearchErrors";

const locationItems = [
  { description: "here", code: "", current: true },
  { description: "there", code: "", current: false },
];
function TabAdvanced() {
  /* Grab items from redux to be used in dropdowns (could have easily been done through props) */
  const certificates = useSelector((state) => state.tabAdvanced.certificates);
  const ewcJobs = useSelector((state) => state.tabAdvanced.ewcJobs);
  const programs = useSelector((state) => state.tabAdvanced.programs);
  const loading = useSelector((state) => state.inmates.loading);
  const offenseCategoryTypes = useSelector(
    (state) => state.tabAdvanced.offenseCategoryTypes
  );
  const dispatch = useDispatch();

  // Keep up with selected dropdown items to be used in fetch call
  const [selectedCertificates, setSelectedCertificates] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState([]);
  const [selectedEWC, setSelectedEWC] = useState([]);
  const [selectedOffense, setSelectedOffense] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Filter or exclude toggle for offense category type
  const [offenseToggle, setOffenseToggle] = useState(false);

  // Show COE show/hide COE on mobile so it does not take up too much space on moblie
  const [showCOE, setShowCOE] = useState(false);

  //
  const Wrapper = window.innerWidth < 640 ? "div" : React.Fragment;

  // Handles submit button press
  const handleSubmit = () => {
    //Show loading, reset list, hide all errors
    dispatch(showLoading());
    dispatch(reset());
    dispatch(hideError02());
    dispatch(hideFailed());
    dispatch(hideWarning01());
    dispatch(hideError03());

    // Create varibles so you can format selected items for api call
    let certificates = selectedCertificates;
    let programs = selectedPrograms;
    let ewc = selectedEWC;
    let offense = selectedOffense;
    let sDate = startDate;
    let eDate = endDate;

    // Nothing selected, show error, hide loading
    if (
      certificates.length == 0 &&
      programs.length == 0 &&
      ewc.length == 0 &&
      offense.length == 0 &&
      sDate == "" &&
      eDate == ""
    ) {
      dispatch(showError02());
      dispatch(hideLoading());
      return;
    }
    // If value is selected then format
    if (certificates.length != 0) {
      certificates = certificates.join("-") + "-";
    }
    if (programs.length != 0) {
      programs = programs.join("-") + "-";
    }
    if (ewc.length != 0) {
      ewc = ewc.join("-") + "-";
    }
    if (offense.length != 0) {
      if (offenseToggle == true) {
        offense = "=" + offense.join("-") + "-";
      } else if (offenseToggle == false) {
        offense = "x" + offense.join("-") + "-";
      }
    }
    // Check to see if there is a start date and end date selected
    if ((sDate == "" || eDate == "") && !(sDate == "" && eDate == "")) {
      dispatch(showError03());
      dispatch(hideLoading());
      return;
    }
    if (eDate == "") {
      eDate = "";
      sDate = "";
    }

    // Create fetch string with the formatted items
    let fetchString =
      env +
      "inmateSearchAdvanced.do?method=search&certificates=" +
      certificates +
      "&programs=" +
      programs +
      "&ewc=" +
      ewc +
      "&offenseCategoryType=" +
      offense +
      "&releaseDate=" +
      sDate +
      eDate;
    //console.log(fetchString);

    // Perform api call
    fetch(fetchString)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.length == 0) {
          dispatch(showFailed());
        }
        if (data.length == 250) {
          dispatch(showWarning01());
        }
        dispatch(insert(data));
        dispatch(hideLoading());
        handleScroll();
      })
      .catch((e) => console.log(e));
  };

  // Moves view to top of list for moblie users when they submit form
  function handleScroll() {
    document.querySelector('[id="top-of-list"]').scrollIntoView();
  }

  return (
    <div
      className=""
      onKeyDown={(e) => {
        // If enter key is pressed then submit
        if (e.keyCode === 13) {
          handleSubmit(e);
        }
      }}
    >
      <div className=" md:flex block">
        {/* PHONE VIEW DROPDOWNS  (Dropdown is set above the form in small view) ///////////////////////////////////////////////////////////*/}
        <div className="pb-2 mt-2 md:hidden block text-center">
          <Dropdown
            title={"Certificates"}
            items={certificates}
            selectedCodes={selectedCertificates} // Passing selected Certificates to perform updates to that state
            current={setSelectedCertificates} //Passing set state function to child component
            z={4}
            id={"location-large"}
          />
          <Dropdown
            title={"Programs"}
            items={programs}
            selectedCodes={selectedPrograms}
            current={setSelectedPrograms}
            z={3}
            id={"program-large"}
          />
          <Dropdown
            title={"Earned Worked Credit "}
            items={ewcJobs}
            selectedCodes={selectedEWC}
            current={setSelectedEWC}
            z={2}
            id={"program-large"}
          />
          <div className="grid">
            <Dropdown
              title={"Most Serious Offense Category Types"}
              items={offenseCategoryTypes}
              selectedCodes={selectedOffense}
              current={setSelectedOffense}
              z={1}
              id={"other-large"}
            />
            <div className="flex m-auto">
              <ToggleWithCheck
                enabled={offenseToggle}
                setEnabled={setOffenseToggle}
              />
              <p className={offenseToggle ? "block m-2" : "hidden"}>Filter</p>
              <p className={offenseToggle ? "hidden" : "block m-2"}>Exclude</p>
            </div>
          </div>

          <div className="m-auto">
            <DateSelect
              title={"Projected Release Date Start"}
              setParentDate={setStartDate}
              defaultDate={""}
            />
            {/* <ArrowNarrowRightIcon className="h-6 w-6 mx-2 my-10 " /> */}
            <DateSelect
              title={"Projected Release Date End"}
              setParentDate={setEndDate}
              defaultDate={""}
            />
            <div className=" mt-9  ">
              <button
                onClick={handleSubmit}
                className="inline-flex px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-primary hover:bg-orange-light hover:text-blue-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
              >
                Submit
              </button>
              <div
                className="inline-flex ml-5"
                style={{ display: loading ? "" : "none" }}
              >
                <Loading
                  type={"spinningBubbles"}
                  color={"black"}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* /////////Start of Large view //////////////////////////////////////////////////////////////////////// */}
        <div
          className="md:p-2 h-full  w-full md:grid grid-cols-4 hidden"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSubmit(e);
            }
          }}
        >
          <Dropdown
            title={"Certificates"}
            items={certificates}
            selectedCodes={selectedCertificates}
            current={setSelectedCertificates} //Passing set state function to child component
            z={5}
            id={"location-large"}
          />
          <Dropdown
            title={"Programs"}
            items={programs}
            selectedCodes={selectedPrograms}
            current={setSelectedPrograms}
            z={5}
            id={"program-large"}
          />
          <Dropdown
            title={"Earned Worked Credit "}
            items={ewcJobs}
            selectedCodes={selectedEWC}
            current={setSelectedEWC}
            z={5}
            id={"program-large"}
          />
          <div className="grid">
            <Dropdown
              title={"Most Serious Offense Category Types"}
              items={offenseCategoryTypes}
              selectedCodes={selectedOffense}
              current={setSelectedOffense}
              z={5}
              id={"other-large"}
            />
            <div className="flex mx-9">
              <ToggleWithCheck
                enabled={offenseToggle}
                setEnabled={setOffenseToggle}
              />
              <p className={offenseToggle ? "block m-2" : "hidden"}>Filter</p>
              <p className={offenseToggle ? "hidden" : "block m-2"}>Exclude</p>
            </div>
          </div>

          <div className=" pl-24 col-span-4 inline-flex m-auto">
            <DateSelect
              title={"Projected Release Date Start"}
              setParentDate={setStartDate}
              defaultDate={""}
            />
            <ArrowNarrowRightIcon className="h-6 w-6 mx-2 my-10 " />
            <DateSelect
              title={"Projected Release Date End"}
              setParentDate={setEndDate}
              defaultDate={""}
            />
            <div className=" mt-9 ml-5 block">
              <button
                onClick={handleSubmit}
                className="inline-flex  ml-2 px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-primary hover:bg-orange-light hover:text-blue-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
              >
                Submit
              </button>
              <div
                className="inline-flex  ml-5 float-right"
                style={{ display: loading ? "" : "none" }}
              >
                <Loading
                  type={"spinningBubbles"}
                  color={"black"}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* ///////////////////////////////////////////////////////////////////////////////////// */}
      </div>
      <div className="xl:flex xl:justify-center  block">
        {/* Phone view COE. Allows user to show/hide */}
        {/* <div className=" m-auto rounded-md sm:hidden  ">
          <div
            className="hover:bg-gray-200 rounded-md"
            onClick={() => setShowCOE(!showCOE)}
          >
            {!showCOE ? (
              <PlusCircleIcon className="h-5 float-left mt-1 mt-1" />
            ) : (
              <MinusCircleIcon className="h-5 float-left mt-1 mt-1" />
            )}
            <div className="ml-6 pt-px hover:bg-gray-200">COE</div>
            <div className="h-px bg-black mt-1"></div>
          </div>
          {showCOE ? <COE /> : null}
        </div> */}
        {/* END OF PHONE VIEW COE ///////////////// */}

        {/* Large view COE */}
        {/* <Wrapper className="sm:block hidden p-0 m-0">
          <COE />
        </Wrapper> */}
        {/* END LARGE VIEW COE */}

        <InmateList />
      </div>
      <SearchErrors />
      {/* *********************************************************** */}
    </div>
  );
}

export default TabAdvanced;
